var React = require('react');

function Bq (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#21468b","d":"M0 0h640v480H0z","key":0}),React.createElement("path",{"fill":"#fff","d":"M0 0h640v320H0z","key":1}),React.createElement("path",{"fill":"#ae1c28","d":"M0 0h640v160H0z","key":2})]);
}

Bq.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Bq;

Bq.default = Bq;
